import * as moment from 'moment';
import { hyphenatedMonthDay } from '@liquitics/transaction';

export class BucketDef {
    private expanded: boolean;

    constructor(
        public bucketEndDate: moment.Moment,
        public bucketStartDate?: moment.Moment,
        public expandable?: boolean,
        public bucketName?: string,
        public bucketNamer?: (bucketDef: BucketDef) => string,
    ) {
        if (!bucketName) {
            this.bucketName = this.formatMomentName(this.bucketEndDate);
        }
        if (!bucketStartDate) {
            this.bucketStartDate = this.bucketEndDate;
        }
        if (!expandable) {
            this.expandable = false;
        }
        if (this.bucketNamer) {
            this.bucketName = this.bucketNamer(this);
        }
        this.expanded = !this.expandable;
    }


    contains(m: moment.Moment): boolean {
        return m >= this.bucketStartDate && m <= this.bucketEndDate;
    }

    expand(): void {
        this.expanded = true;
    }

    collapse(): void {
        this.expanded = false;
    }

    isExpanded(): boolean {
        return this.expanded;
    }

    getBucketNameFromMoment(m: moment.Moment) {
        if (!this.expandable || !this.expanded) {
            return this.bucketName;
        } else {
            const name = this.formatMomentName(m);
            // if (this.isExpanded() && moment.date() == this.bucketStartDate.date()) {
            //     name = this.bucketName + ": " + name;
            // }
            return name;
        }

    }

    getBucketNameFromString(dateStr: string) {
        return this.getBucketNameFromMoment(moment.utc(dateStr));
    }

    formatMomentName(m: moment.Moment) {
        return hyphenatedMonthDay(m);
    }
}
